import ViewController from "core/views/view.controller";
import {Items} from "core/model/items.model";
import Store from "store/store";

export default class NewBookingServiceCtrl extends ViewController {
    static $inject = ['$scope', '$state', '$translate', '$ionicHistory', '$ionicTabsDelegate', 'Services'];

    constructor() {
        super(...arguments);
        this.hasViewParams = true;

        this.searchTerm = null;
        this.booking = {};
        this.serviceGroupItems = null;
        this.noServiceSelected = true;
    }

    $onViewBeforeEnter() {
        this.$ionicTabsDelegate.showBar(false);
        this.loadBookingState();

        this.Services.allGroups().then((serviceGroups)=> {
            this.serviceGroupItems = this.createServiceGroupItems(serviceGroups, this.booking.services)
        });
    }

    next() {
        this.saveBookingState();
        this.toState('tab.new-booking-duration');
    }

    cancel() {
        this.viewState('booking', null);
        this.$ionicHistory.goBack();
        this.$ionicTabsDelegate.showBar(true);
    }

    clearSearch(){
        this.searchTerm = null;

        for(var groupItem of this.serviceGroupItems.all) {
            groupItem.disabled = false;

            for(var serviceItem of groupItem.subItems){
                serviceItem.disabled = false;
            }
        }
    }

    search(){
        if(this.searchTerm){
            var searchTerm = this.searchTerm.toLowerCase();

            for(var groupItem of this.serviceGroupItems.all) {
                let groupDisabled = true;

                for(var serviceItem of groupItem.subItems){
                    var serviceName = serviceItem.value.name.toLowerCase();
                    serviceItem.disabled = !serviceName.includes(searchTerm);

                    if(!serviceItem.disabled){
                        groupDisabled = false;
                    }
                }

                groupItem.disabled = groupDisabled;
            }
        }else{
            this.clearSearch();
        }
    }

    loadBookingState() {
        this.booking = this.viewParams.booking || Store.get('booking') || {};
    }

    saveBookingState() {
        if (this.serviceGroupItems) {
            this.booking.services = this.serviceGroupItems.selectedValues(false, true);
        }

        this.viewState('booking', this.booking);
    }

    selectNoService() {
        if (this.serviceGroupItems) {
            this.serviceGroupItems.reset();
        }

        this.noServiceSelected = true;
        this.booking.duration = null;
    }

    selectServiceItem(item) {
        item.toggle();
        this.noServiceSelected = !this.serviceGroupItems.hasSelected();
        this.booking.duration = null;
    }

    createServiceGroupItems(serviceGroups, selectedServices) {
        var serviceItems = Items.create(serviceGroups, 'services');

        if (selectedServices) {
            serviceItems.selectAllBy(selectedServices, 'id');
        }

        var self = this;
        serviceGroups.forEach((serviceGroup)=> {
            if (serviceGroup.id === 'ungrouped') {
                self.$translate('UNGROUPED_SERVICES').then((translation)=> {
                    serviceGroup.name = translation;
                });
            }
        });

        return serviceItems;
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/views/new-booking-service/new-booking-service.controller.js